import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Check, Loader2, ShieldCheck, Lock } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../api";
import { useAuth } from "../context/AuthContext";
import { BENEFITS } from "../mock";

export default function CheckoutPage() {
  const { jobId } = useParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const start = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        origin_url: window.location.origin, job_id: jobId, user_id: user?.id,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not start checkout.");
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <div className="hero-gradient py-14 px-5 min-h-[70vh]">
        <div className="max-w-lg mx-auto bg-white rounded-2xl border border-black/10 shadow-[0_20px_50px_-20px_rgba(124,34,51,0.2)] p-7">
          <span className="inline-block text-[13px] font-medium text-[#7c2233] bg-[#f7e4e6] rounded-full px-3 py-1">1 month free</span>
          <h1 className="font-display text-3xl text-[#1f1a1b] mt-3">Activate your membership</h1>
          <p className="text-[15px] text-[#5a5254] mt-1">
            You won't be charged today. Your first month is <strong>free</strong>, then just <strong>$15.99/month</strong>. Cancel anytime.
          </p>

          <div className="mt-5 rounded-xl border border-black/10 p-5">
            <div className="flex items-baseline justify-between">
              <span className="font-medium text-[#1f1a1b]">SimplySitter Membership</span>
              <span className="font-display text-2xl text-[#1f1a1b]">$15.99<span className="text-sm text-[#8a8285]">/mo</span></span>
            </div>
            <div className="flex items-center justify-between mt-2 text-[14px]">
              <span className="text-[#5a5254]">Due today</span>
              <span className="font-semibold text-[#2e7d32]">$0.00</span>
            </div>
          </div>

          <ul className="mt-5 space-y-2.5">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-2.5 text-[14px] text-[#3a3436]">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-[#7c2233] flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 text-white" strokeWidth={3} />
                </span>{b}
              </li>
            ))}
          </ul>

          <button onClick={start} disabled={loading}
            className="w-full mt-6 h-12 inline-flex items-center justify-center gap-2 rounded-xl bg-[#7c2233] hover:bg-[#661b29] disabled:opacity-70 text-white font-medium transition-colors">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
            Continue to secure checkout
          </button>
          <div className="flex items-center justify-center gap-1.5 mt-3 text-xs text-[#8a8285]">
            <ShieldCheck className="w-3.5 h-3.5" /> Secured by Stripe
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
